import React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';

import { createGoogleAuthURL, GoogleLoginService } from '../../services/Google';
import Loader from '../Loader';

import styles from './socialLogin.module.scss';

interface Props {
  clientId: string;
  scope?: string | string[];
  children: React.ReactNode;

  onSuccess(response: string): void;

  onFailure?(error: Error, blocked?: boolean): void;
}

export default function GoogleLoginButton(props: Props) {
  const service = useRef(new GoogleLoginService());
  const [loading, setLoading] = useState(service.current.canLoad);
  const location = useLocation();
  const scope = props.scope ?? ['profile', 'email'];

  const handleClick = useCallback(async () => {
    if (loading) return;
    if (service.current.isBlocked) {
      navigate(createGoogleAuthURL(location, scope));
      return;
    }
    setLoading(true);
    service.current.login();
  }, [loading, props.clientId, props.scope]);

  useEffect(() => {
    return service.current.load(() => setLoading(false), props.onSuccess, scope);
  }, []);

  return (
    <button className={styles.google} onClick={handleClick} type="button">
      {loading ? <Loader /> : props.children}
    </button>
  );
}
